export const taxonomyLevel1Values = [
  'Amazon devices & accessories',
  'Appliances',
  'Arts, crafts & sewing',
  'Automotive',
  'Baby products',
  'Beauty & personal care',
  'Books',
  'Car & vehicle electronics',
  'Cds & vinyl',
  'Cell phones & accessories',
  'Clothing, shoes & jewelry',
  'Collectibles & fine art',
  'Digital educational resources',
  'Educational courses',
  'Electronics',
  'Food service equipment & supplies',
  'Gift cards',
  'Grills & outdoor cooking',
  'Grocery & gourmet food',
  'Handmade products',
  'Health & household',
  'Heavy duty & commercial vehicle equipment',
  'Heavy duty & commercial vehicles parts',
  'Hobbies',
  'Home & business services',
  'Home & kitchen',
  'Hunting & fishing',
  'Industrial & scientific',
  'Instrument accessories',
  'Janitorial & sanitation supplies',
  'Kindle ebooks',
  'Kindle store',
  'Kitchen & dining',
  'Lab & scientific products',
  'Lights & lighting accessories',
  'Magazine subscriptions',
  'Medical supplies & equipment',
  'Mobility & daily living aids',
  'Motorcycle & powersports',
  'Movies & tv',
  'Musical instruments',
  'Office electronics',
  'Office products',
  'Patio, lawn & garden',
  'Pet supplies',
  'Power & hand tools',
  'Power tool parts & accessories',
  'Professional dental supplies',
  'Remote & app controlled vehicle parts',
  'Remote & app controlled vehicles & parts',
  'Restaurant appliances & equipment',
  'Returns',
  'Safety & security',
  'Small appliance parts & accessories',
  'Software',
  'Sports & fitness',
  'Sports & outdoors',
  'Tools & home improvement',
  'Toys & games',
  'Video games'
]
